import React from 'react'
import styled from 'styled-components';

const Frame = styled.div`
  display: inline-block;
  margin-right: 3px;
  padding: 0px 10px;
  height: 20px;
  font-size: 16px;
  line-height: 20px;
  border-radius: 25px;
  background-color: #1b1b1b;
  color: #c1c1c1;
  cursor: pointer;
  &:hover {
    background-color: #404040;
  }
  `;

const Chip = ({label, onClick}) => {
  return (
    <Frame onClick={onClick}>
      #{label}
    </Frame>
  );
};

export default Chip